import { createMemoryHistory, createBrowserHistory } from 'history';

import config from '../config';

export const browserHistory = (config.HISTORY_TYPE === 'memory' ? createMemoryHistory : createBrowserHistory)({
    basename: '/'
});
